export default __webpack_public_path__ + "static/smirking-21907f52bd371c8e470e8a2983fec441.svg";